export const permissionsDocumentsReadonly = [
  "documents-readonly",
  "documents-full",
  "everything-readonly",
  "everything-full",
];
